import { useStateValue } from '../../context/StateValueContext';
import { PERMISSIONS } from '../../constants/permissions';
import AdminCdrn from './Cdrn';
import ClientCdrn from '../ClientAlerts/ClientCdrn';

export default function CdrnSwitcher() {
  const [{ user }] = useStateValue();

  if (user?.permissions?.includes(PERMISSIONS.ALERTS_ALL)) {
    return <AdminCdrn />;
  }

  return <ClientCdrn />;
}
